import { render } from "./KeyboardTyping.vue?vue&type=template&id=2f56309b&scoped=true"
import script from "./KeyboardTyping.vue?vue&type=script&lang=js"
export * from "./KeyboardTyping.vue?vue&type=script&lang=js"

import "./KeyboardTyping.vue?vue&type=style&index=0&id=2f56309b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f56309b"]])

export default __exports__